import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-invoice-make-multi-orders',
  templateUrl: './invoice-make-multi-orders.component.html',
  styleUrls: ['./invoice-make-multi-orders.component.css']
})
export class InvoiceMakeMultiOrdersComponent implements OnInit {
    custNo;

    invoiceMethodNo;

    businessCoNo;

    public menu?: Menu;

    public itemsListMultiOrders: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.custNo = this.stateService.getStateParams()['cust_no'];
        this.invoiceMethodNo = this.stateService.getStateParams()['invoicemethod_no'];
        this.businessCoNo = this.stateService.getStateParams()['businessco_no'];
    }

    private async loadMenu() {
        if (!!this.custNo && !!this.invoiceMethodNo && !!this.businessCoNo) {
            this.menu = (await this.datatask.Post(1759, {
                cust_no: this.custNo,
                invoicemethod_no: this.invoiceMethodNo,
                businessco_no: this.businessCoNo
            }))[0];
        }
    }

    private async loadMultiOrders() {
        if (!this.menu) return;

        this.itemsListMultiOrders = await this.datatask.Post(1760, this.menu);
    }

    private async init() {
        await this.loadMenu();
        this.loadMultiOrders();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    businessco_no: string;
    cust_name: string;
    invoice_date: string;
    invoicemethod_no: string;
    deliverydate_tom: string;
    businessco_companyname: string;
    invoicemethod_name: string;
    cust_no: string;
}
